import { useFormik } from "formik";
import * as Yup from "yup";

const useSubscriptionForm = (handleSubmit) => {
  return useFormik({
    initialValues: {
      email: "",
      name: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Էլ․ Հասցեի անվավեր ձևաչափ")
        .required("Պարտադիր դաշտ (Էլ․ Հասցե)"),
      name: Yup.string()
        .min(3, "Ամենաքիչը 3 նիշ")
        .required("Պարտադիր դաշտ (Անուն)"),
    }),
    onSubmit: (values) => {
      handleSubmit(values.email, values);
    },
  });
};

export default useSubscriptionForm;
